import React, { useEffect } from 'react';
import styled from 'styled-components';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { useMsal } from '@azure/msal-react';
import appsettings from 'nallian-shared-ui/lib/config/appsettings';
import { history } from 'nallian-shared-ui/lib/config/history';
import { Segment, Loader, Flex } from 'nallian-shared-ui/lib/components';
import communityService from 'nallian-shared-ui/lib/services/communityService';
import { loginRequest } from 'nallian-shared-ui/lib/authentication/constants/config';
import BasicLayout from '../../app/components/BasicLayout';
import GuestActions from './GuestActions';
import CommunityText from './CommunityText';
import AwaitApplicationLoaded from '../hoc/AwaitApplicationLoaded';
import { WELCOME_TEXT_TYPE_ID } from '../../../mgmt/communities/components/legalAndTexts/constants';

const StyledSegment = styled(Segment)`
  max-width: 50rem;
  min-height: 15rem;
  &.ui.segment {
    margin: 0 auto;
  }
`;

const LandingPage = ({ myCommunityFetch }) => {
  // below is the only way possible since we're not in our provider of msal yet.
  // eslint-disable-next-line no-undef
  const { instance } = useMsal();

  useEffect(() => {
    const check = async () => {
      try {
        await instance.ssoSilent({
          ...loginRequest,
          authority: appsettings.authority,
        });

        history.push(`/overview`);
        return true;
      } catch (error) {
        // Do nothing because we want to stay on the page since we're not logged in
        return false;
      }
    };

    check();
  }, [instance]);

  return (
    <BasicLayout>
      <StyledSegment>
        {myCommunityFetch.pending && (
          <Flex fluid justifyContent="center">
            <Loader active inline />
          </Flex>
        )}
        {myCommunityFetch.value?.defaultLanguageId && (
          <CommunityText
            language={myCommunityFetch.value?.defaultLanguageId || 'en'}
            communityTag={myCommunityFetch.value?.tag}
            type={WELCOME_TEXT_TYPE_ID}
          />
        )}
        <br />
        <GuestActions />
      </StyledSegment>
    </BasicLayout>
  );
};

LandingPage.propTypes = { myCommunityFetch: PropTypes.object.isRequired };

export default compose(AwaitApplicationLoaded, communityService)(LandingPage);
